import { tokens } from '@servicetitan/tokens/core';
import styled from 'styled-components';

type ContactCenterContainerProps = {
  $showIcon?: boolean;
};

export const ContactCenterContainer = styled.div<ContactCenterContainerProps>`
  align-items: center;
  display: flex;
  gap: ${(p) => (p.$showIcon ? tokens.spacing1 : tokens.typescale1)};
`;
